import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";

export function getHowWeDigi(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "Na začátku věnujeme dostatek času sp[[konzultaci a analýze firemních procesů.]] Jen tak vám dokážeme dát doporučení a navrhnout řešení na míru vašemu podnikání.",
		},
		{
			desc: "Ve druhé fázi sp[[navrhneme řešení a pustíme se do digitalizace procesů.]] Pokud je to potřeba, zařídíme také integraci (propojení) firemních systémů.",
		},
		{
			desc: "Jakmile je hotová digitalizace, sp[[pomůžeme vám digitální procesy zautomatizovat]] (např. automatická fakturace, automatické notifikace apod.).",
		},
		{
			desc: "Po dokončení digitalizace a automatizace vám budeme k ruce v rámci sp[[dlouhodobé podpory.]]",
		},
	];
}
